export const USER_INFO_LOCAL_STORAGE_KEY = 'userInfo';
